import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';

import { armyListUnitsByOrganisation } from '@Selectors/builder/myArmyList/make/armyListUnitsByOrganisation';

import Repeater from '@Utils/Repeater';
import ArmyListUnitSection from './army-list_unit.section';
import {
  ArmyListUnitsByOrganisationView
} from '@Selectors/builder/myArmyList/make/view/ArmyListUnitsByOrganisationView';

const ArmyListUnits: React.FC<ArmyListUnitsProps> = ({ armyListUnits }) => {

  return (
    <>
      <Repeater data={armyListUnits} indexPrefix="army-list-unit-organisation">
        {
          (item: ArmyListUnitsByOrganisationView) => (
            <ArmyListUnitSection name={item.name} good={item.good} longTotal={item.longTotal}
                                 armyListUnits={item.armyListUnits} organisationId={item.id} />
          )
        }
      </Repeater>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  armyListUnits: armyListUnitsByOrganisation(state)
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListUnits);

type ArmyListUnitsProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
